import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ImageThemeResponse } from "../../../utility/interfaces/babyWeekImageDataInterface";

const initialState: ImageThemeResponse = {
  imageThemes: [],
  currentPregnancyWeek: 0,
};

const imageThemesSlice = createSlice({
  name: "babySizeImageThemes",
  initialState,
  reducers: {
    setImageThemes: (state, action: PayloadAction<ImageThemeResponse>) => {
      state.imageThemes = action.payload.imageThemes;
      state.currentPregnancyWeek = action.payload.currentPregnancyWeek;
    },
    clearImageThemes: (state) => {
      state.imageThemes = [];
      state.currentPregnancyWeek = 0;
    },
  },
});

export const { setImageThemes, clearImageThemes } = imageThemesSlice.actions;

export default imageThemesSlice.reducer;
